export default __webpack_public_path__ + "static/media/template_5_new.c37a0bed.png";